





























































































import Vue from 'vue'
import { parseMap, convertSeconds, isDisplayShow } from '@/utils/index'
import { planStatusMap, planStatusMapColor, planCategoryMap } from '@/utils/commonDef'
import { ProductionStatisticsServiceProxy } from '@/service-proxies/app-v2/coproduction.service-proxies'
import { TenantBizFieldServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
const productionStatisticsServiceProxy = new ProductionStatisticsServiceProxy()
const tenantBizFieldServiceProxy = new TenantBizFieldServiceProxy()
import AdvancedSearch from '@/components/AdvancedSearch'
import { exportPerformance } from '../../../../../api/api'

export default Vue.extend({
  name: '',
  components: {
    AdvancedSearch
  },
  data() {
    return {
      data: [],
      loading: false,
      pageSize: 30,
      currentPage: 1,
      searchDto: {
        typeId: '',
        filterPlus: false,
        planStatus: ['1', '2', '3', '4'],
        param: {}
      },
      planStatusMap,
      planStatusMapColor,
      planStatusList: parseMap(planStatusMap),
      selectedRowKeys: [],
      chooseArr: [],
      currentPlan: null,
      customRow: (record) => {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self: any = this
        return {
          on: {
            click: (e) => {
              self.currentPlan = { ...record }
              self.selectedRowKeys = [self.currentPlan.id]
            }
          }
        }
      },
      planCategoryMap,
      totalContent: 0, // 表格总数
      productColums: [], // 产品表格的字段
      showColumns: [],
      tableScrollWidth: 1700,
      isLoadComplete: false,
      tableScrollHeight: 300,
      selectArr: [],
      defaultSelect: {}
    }
  },
  created() {
    this.getSelectArr()
    this.getTableColumn()
    this.load()
  },
  updated() {
    this.tableScrollHeight = document.querySelector('#main-page').clientHeight - 124
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys }: any = this
      return {
        selectedRowKeys,
        onChange: (selectedRowKeys: [], selectedRows: []) => {
          console.log(selectedRowKeys, selectedRows, 'vvvvvvv')
          this.selectedRowKeys = selectedRowKeys
          if (this.selectedRowKeys.length === 1) {
            this.currentPlan = this.data.find((res) => res.id === this.selectedRowKeys[0]) || {}
          }
          this.chooseArr = selectedRows
        },
        getCheckboxProps(record) {
          return {
            style: {
              display: record.processName ? 'block' : 'none'
            },
            props: {
              disabled: record.processName ? false : true
            }
          }
        }
      }
    },
    hasSelected() {
      return this.selectedRowKeys.length > 0
    },
    exportFn() {
      const params = {
        bizCode: 'stat_employee_performance',
        bizDataId: this.searchDto.typeId,
        current: this.currentPage,
        size: this.pageSize,
        tenantId: ''
      }
      return exportPerformance.bind(this, this.searchDto, params)
    }
  },
  watch: {
    'searchDto.planStatus'() {
      this.load()
    }
  },
  methods: {
    getSelectArr() {
      let arr = JSON.parse(localStorage.getItem('coproduction'))
      let arrX = []

      for (var i = 0; i < arr.length; i++) {
        let obj = {
          label: arr[i].name,
          value: arr[i].id
        }
        arrX.push(obj)
      }
      this.selectArr = arrX

      this.defaultSelect = {
        key: arr[0].id,
        label: arr[0].name
      }
      this.searchDto.typeId = arr[0].id
    },
    changeProduction(e) {
      console.log(e)
      this.searchDto.typeId = e.key.toString()
      this.getTableColumn()
      this.load()
    },
    cancelChooseArr(val) {
      this.selectedRowKeys = []
      this.selectedRows = []
      this.chooseArr = []
    },
    showStatusColor(value) {
      const status = this.searchDto.planStatus.find((res) => res == value)
      let color = ''
      if (status) {
        color = this.planStatusMapColor[value]
      }
      return color
    },
    inSearchStatus(value) {
      const status = this.searchDto.planStatus.find((res) => res == value)
      let boolean = false
      if (status) {
        boolean = true
      }
      return boolean
    },
    inputStatus(value) {
      const newTags = [...this.searchDto.planStatus]
      const status = this.searchDto.planStatus.find((res) => res == value)
      if (!status) {
        this.searchDto.planStatus.push(value)
      } else {
        this.searchDto.planStatus = newTags.filter((res) => res != value)
      }
    },
    reload(data) {
      this.searchDto.filterPlus = true
      this.searchDto.param = data
      this.currentPage = 1
      this.load()
    },
    load() {
      this.selectedRowKeys = []
      this.loading = true
      productionStatisticsServiceProxy
        .getPageEmployeePerformance(this.currentPage, this.searchDto, this.pageSize)
        .then((re) => {
          this.loading = false
          this.isLoadComplete = true
          this.data = []
          if (re.records.length > 0) {
            re.records.forEach((res: any, index) => {
              // res.id = res.planCode + res.processCode + res.producerCode + res.sort
              res.index = index
              res.differenceTime = convertSeconds(res.differenceTime)
              res.standardTime = convertSeconds(res.standardTime)
              res.standardTotalTime = convertSeconds(res.standardTotalTime)
              res.workTime = convertSeconds(res.workTime)
            })
            this.currentPlan = re.records[0]
            this.selectedRowKeys = [this.currentPlan.id]
            this.totalContent = re.total
            // this.data = re.records

            let dataLength = re.records.length
            let copy = re.records
            let needPush = 0
            if (dataLength < 30) {
              needPush = 30 - dataLength
              for (var k = 0; k < needPush; k++) {
                let obj: any = {
                  // id: 'none'
                }
                copy.push(obj)
              }
            }

            this.data = copy
            console.log(this.data, 'aaaaaaaaaaaaaa')
          } else {
            this.totalContent = 0
            let dataLength = re.records.length
            let copy = re.records
            let needPush = 0
            if (dataLength < 30) {
              needPush = 30 - dataLength
              for (var k = 0; k < needPush; k++) {
                let obj: any = {
                  // id: 'none'
                }
                copy.push(obj)
              }
            }

            this.data = copy
          }
        })
    },
    pageIndexchange(currentPage) {
      this.currentPage = currentPage
      this.chooseArr = []
      this.load()
    },
    // 获取指定业务的字段列表
    async getTableColumn() {
      this.productColums = []
      const colums = await tenantBizFieldServiceProxy.getTenantBizField(
        'stat_employee_performance',
        this.searchDto.typeId
      )
      console.log(colums)
      this.productColums = colums
      this.handleColumns()
    },
    handleColumns() {
      this.showColumns = []
      if (!this.productColums || !this.productColums.length) {
        return
      }
      // 字段排序
      this.productColums.sort((a, b) => {
        return a.sort - b.sort
      })
      // 字段显隐
      let columns = []
      this.productColums.map((item) => {
        if (isDisplayShow(item.isDisplay, 2)) {
          // 自定义字段：产品类型
          const temp: any = {
            title: item.title,
            key: item.code,
            dataIndex: item.code,
            ellipsis: true
          }
          if (temp.key === 'planCode') {
            temp.width = 140
          } else {
            temp.width = (temp.title.length + 1) * 20
          }
          columns.push(temp)
        }
      })
      this.showColumns = [...columns]
      console.log(this.showColumns, 'mmmmmmmmmmmmmmmmm')
      let num = this.productColums.filter((item) => isDisplayShow(item.isDisplay, 2)).length
      this.tableScrollWidth = num * 100
    },
    totalFanyi(number: any) {
      const total = this.$t('Total…items')
      return total.replace('{0}', number)
    }
  }
})
